import Typography from "@common/components/Typography";
import Grid from '@mui/material/Grid2';
import { Divider, Drawer, SxProps } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { WithGrow } from "../WithGrow";

interface IHeaderTitleProps {
  title?: string;
  closeButton?: React.ReactNode | [React.ReactNode];
  headerContent?: never;
  bottomContent?: React.ReactNode;
}
interface IHeaderContentProps {
  headerContent?: React.ReactNode;
  title?: never;
  closeButton?: never;
  bottomContent?: React.ReactNode;
}
type HeaderProps = IHeaderContentProps | IHeaderTitleProps;

type RightDrawerProps = {
  open: boolean;
  onClose: Function;
  className?: string;
  width?: string;
  childrenContainerSx?: SxProps;
  autoMargin?: boolean;
  testId?: string;
  noBackdrop?: boolean;
  drawerRef?: React.Ref<HTMLDivElement | null>;
} & HeaderProps;

const isHeaderTitle = (x: HeaderProps): x is IHeaderTitleProps =>
  (x as IHeaderContentProps).headerContent === undefined;

const RightDrawer = (props: PropsWithChildren<RightDrawerProps>) => {
  const {
    open,
    onClose,
    title,
    width = "500px",
    closeButton,
    className,
    childrenContainerSx,
    autoMargin = true,
    testId = "right-drawer",
    noBackdrop = false,
    drawerRef,
  } = props;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => onClose()}
      className={className}
      variant={noBackdrop ? "persistent" : "temporary"}
      hideBackdrop={noBackdrop}
      ModalProps={{
        disableEnforceFocus: noBackdrop,
        disableAutoFocus: noBackdrop,
      }}
      slotProps={{
        paper: {
          elevation: 0,
          sx: { width, backgroundColor: "background.default" },
          ref: drawerRef,
        },
      }}
      data-testid={testId}
    >
      <WithGrow
        fixed={
          <Grid
            sx={{
              backgroundColor: "background.paper",
              py: 1,
              px: 2,
              mb: autoMargin ? 2 : undefined,
            }}>
            {isHeaderTitle(props) ? (
              <Grid
                container
                direction="row"
                sx={{ width: '100%', alignItems: "center",
                  gap: 1 }}>
                <Typography flex={1}>{title}</Typography>
                {closeButton !== undefined ? closeButton : <></>}
              </Grid>
            ) : (
              props.headerContent
            )}
          </Grid>
        }
        direction="column"
        bottomfixed={
          props.bottomContent ? (
            <>
              <Divider />
              <Grid
                sx={{
                  py: 1,
                  px: 2,
                }}>
                {props.bottomContent}
              </Grid>
            </>
          ) : null
        }
      >
        <Grid
          sx={[
            { height: 1, overflowY: "auto" },
            ...(Array.isArray(childrenContainerSx)
              ? childrenContainerSx
              : [childrenContainerSx]),
          ]}>
          {props.children}
        </Grid>
      </WithGrow>
    </Drawer>
  );
};

export default RightDrawer;
